export default "__VITE_ASSET__Ckpv2n4x__"